import types from './mutations-types';
import moment from 'moment';
import { defaultState } from './state';

const resetState_ = state => {
	Object.assign(state, defaultState);
};
const defaultSelect = (state, { optionNm, valueNm }) => {
	// console.log('optionNm', optionNm);
	// console.log('valueNm', valueNm);
	// console.log('length', state[optionNm].length);
	if (state[optionNm].length > 0) state[valueNm] = state[optionNm][0]['value'];
};

const changeValue = (state, data) => {
	if (data.name == 'searchMonth') data.value = moment(data.value).format('YYYY-MM');
	state[`${data.name}`] = data.value;
};

export default {
	resetState_,
	defaultSelect,
	changeValue,
	[types.DEFAULT_ASSIGN]: (state, { key, value }) => {
		state[key] = value;
	},
	[types.SET_SEARCH_PARAM]: (state, { key, value }) => {
		state.searchParams[key] = value;
	},
	[types.SET_OPTION_LIST]: (state, { key, list }) => {
		let list_new = [{ label: 'All', value: '' }];
		list.map(item => {
			list_new.push({ label: item.label, value: item.value });
		});
		state[key] = list_new;
	}
};
